//Uyarı  bir kayıt eklemeden once olup olmadıgını lutfen kontrol ediniz.
export const messages_en = {
  noaccount: "Don't have an account?",
  google: 'Log in with Google',
  loginwithsocial: 'Or login using social network',
  linkden: 'Log in with LinkedIn',
  login: 'Log in',
  loginm: 'Log In',
  signupm: 'Sign Up',
  firstname: 'First Name',
  lastname: 'Last Name',
  email: 'Email',
  password: 'Password',
  pickpassowrd: 'Pick a password',
  onelower: 'At least one lowercase',
  oneuppercase: 'At least one uppercase',
  onenumeric: 'At least one numeric',
  mineightchar: 'Minimum 8 characters',
  suggest: 'Suggestions',
  howdidfind: 'How did you reached us ?',
  agreement: ' I accept terms on conditions specified by this link',
  terms: ' Terms And Conditions.',
  hasaccount: 'Already have a CrowdHrs account?',
  uyari: 'Warning',
  definations: 'Definitions',
  candiStatus: 'Candidate Statues',
  elevels: 'Education Levels',
  topTypes: 'Job Types',
  jobStatus: 'Job Status',
  jobIndus: 'Job Industries',
  jobLocations: 'Job Locations',
  jobSalary: 'Job Salary Types',
  profile: 'Profile',
  changeMyPassword: 'Change my password',
  help: 'Help',
  logout: 'Logout',
  dashboard: 'Dashboard',
  arama: 'Search',
  id: 'ID',
  description: 'Description',
  edulevel: 'Education Levels',
  action: 'Actions',
  addrecord: 'Add New Record',
  search: 'Search...',
  location: 'Locations',
  delete: 'Delete',
  edit: 'Edit',
  linkedInEmail: 'LinkedIn email',
  signupError: 'This Linkedin Profile Already Registered!',
  vieworder: 'View Order',
  hometitle: 'Find a dream job to apply for or refer a candidate',
  locationm: 'Location',
  keyword: 'Keyword',
  findjob: 'Find Job',
  enterkeyword: 'Enter Keyword',
  enterlocation: 'Enter Location',
  home: 'Home',
  contactus: 'Contact Us',
  getstarted: 'Get Started',
  filters: 'Filters',
  jobtype: 'Job Type',
  worktype: 'Work Type',
  dateposted: 'Date Posted',

  alljobs: 'All Job Types',
  fulltime: 'Full Time',
  partime: 'Part Time',
  remote: 'Remote',
  onside: 'Onsite',
  thisweek: 'This Week',
  today: 'Today',
  contract: 'Contract',
  hybrid: 'Hybrid',
  thismonth: 'This Month',
  temporary: 'Temporary',
  internship: 'Internship',
  any: 'Any',
  clear: 'Clear',
  result: 'View Result',
  name: 'Title',
  companyName: 'Company Name',
  reward: 'Reward',
  createDate: 'Release Date',
  refer: 'Refer',
  apply: 'Apply',
  recruitment: 'Recruitment  Redefined!',
  about: 'About',
  resources: 'Resources',
  legal: 'Legal',
  company: 'Company',
  howitworks: 'How it Works?',
  privacy: 'Privacy Policy',
  contact: 'Contact Us',
  termsofservice: 'Terms of Services',

  subtitle:
    'Apply for your dream job or refer to candidates and get the reward.',
  getCandidateHired: 'When your candidate is hired you will get the reward.',
  workingMultipleCompanies:
    'Working for multiple companies has never been so easy.',
  uploadCV: 'Upload the CV of your candidate.',
  uploadingCV: 'Refer your candidate by uploading CV of your candidate.',
  recruitProcess: 'Follow recruitment process',
  recruitmenProcess:
    'Easily track the recruitment processes of all your candidates.',
  getReward: 'Get the reward',
  gettingReward: 'Get the reward amount when your candidate is hired.',
  companyRegister: 'Start a free tour for your company job openings',
  companyInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  recruiterRegister: 'START TO USE AS A RECRUITER',
  clientRegister: 'START TO USE AS A CANDIDATE',
  companyButton: 'Company Free Start',
  recruiterButton: 'Recruiter Free Start',
  clientButton: 'Candidate Free Start',
  sektor: 'SECTOR',
  genelnitelik: 'QUALIFICATIONS',
  istanimi: 'JOB DESCRIPTION',
  odul: 'REWARD',
  yayintarih: 'Release Date',
  gorunme: 'Views',
  benzerisler: 'Similar Jobs',
  recruiter: 'Recruitment Specialist',
  mesagtorec: 'Message to recruiter',
  fullname: 'Name',
  linkedinPage: 'Linkedin Page',
  role: 'Role',
  users: 'Users',
  userList: 'User Lists',
  logo: 'Logo',
  industry: 'Industry',
  website: 'Website',
  accManager: 'Account Manager',
  companies: 'Companies',
  companyList: 'Companies List',
  cancel: 'Cancel',
  save: 'Save',
  companyedit: 'Company Edit',
  phone: 'Phone',
  aphone: 'Alternate Phone',
  nemail: 'Notification Email',
  addlogo: 'Add New Logo (PDF, JPG, PNG)',
  address: 'Address',
  country: 'Country',
  city: 'City',
  selectCity: 'Select Your City',
  selectCountry: 'Select Your Country',
  state: 'State /Province/Region',
  zipcode: 'ZIP Code',
  taxid: 'Tax ID',
  taxoffice: 'Tax Office',
  billaddress: 'Billing Address',
  sameAs: 'Same as company address',
  jobList: 'Job List',
  jobOpenings: 'Job Openings',
  jobs: 'Jobs',
  job: 'Job',
  recruitmentype: 'Recruitment Type',
  candidate: 'Candidate',

  cvdocument: 'CV Document',
  candidateList: 'Candidate Pool',
  candidates: 'Candidates',

  addexistingcandidate: 'Add Existing Candidate',

  addcandidatedetail: 'Add Candidate (Detailed)',
  listcandiate: 'List Candidates',
  mobile: 'Mobile Phone Number',
  aditionalinfo: 'Additional Info',
  newcandidate: 'New Candidate',
  accept: 'I accept',
  inforapp: 'We will inform your candidate about his/her application.',
  listofjobsOne: 'List of Jobs (Select one)*',
  listofjobs: 'List of Jobs*',
  referexisting: 'Refer Exiting Candidate',
  addnewjob: 'Add New Job',
  editjob: 'Edit Job',
  jobname: 'Job Name',
  refcode: 'Reference Code',
  duedate: 'Due Date',
  status: 'Status',
  numposition: 'Number of Positions',
  companyname: 'Company Name',
  companyresponse: 'Company Responsibles',
  visible: 'Visible',
  hide: 'Hide',
  comVisibility: 'Company Visibility',
  jobVisibility: 'Job Visibility',
  notvisible: 'Not Visible',
  onlyforapp: 'Only for Applications',
  appandref: 'Applications & Referrals',
  crowhrresponse: 'CrowdHRs Responsibles',
  jobandcomp: 'Job & Company',
  createNewJob: 'Post a new Job',
  salary: 'Salary',
  definition: 'Definition',
  payment: 'Payment',
  next: 'Next',
  back: 'Back',
  needHelp: 'Need help?',
  currentReward: 'Current Reward Amount Per Position',
  totalPayment: 'Total Payment',
  submitPayment: 'Submit Without Payment',
  addPayment: 'Add Payment',
  addReward: 'Add a Reward',
  currecy: 'Currency',
  positionCount: 'Position Count',
  totalReward: 'Total Reward',
  commission: 'Commission',
  amount: 'Amount',
  vat: 'VAT',
  totalAmount: 'Total Amount to be Payed',
  rewardAmount: 'Reward Amount After Payment',
  totalAfterPayment: 'Total Balance After Payment',
  paymentMethod: 'Payment Method',
  creditCard: 'Credit Card',
  cardDetails: 'Card Details',
  bankTransfer: 'Bank Transfer',
  bankDetails: 'Bank Account Information',
  nameCard: 'Name on the Card',
  cardNumber: 'Card Number',
  cvv: 'CVV',
  mmYY: 'MM/YY',
  bankName: 'Account Name',
  bankAccount: 'Account Number (IBAN)',
  paymentCode: 'Payment Code',
  weWillUpdate:
    '*We will update your reward amount and your balance when we receive your payment.',
  contactType: 'Contact Type',
  minEduLevel: 'Min Education Level',
  minExpLevel: 'Min Experience Level',
  maxExpLevel: 'Max Experience Level',
  gender: 'Gender',
  yes: 'Yes',
  no: 'No',
  male: 'Male',
  female: 'Female',
  notDefined: 'Not Defined',
  salaryType: 'Select a Salary Type',
  minSalary: 'Min Salary',
  maxSalary: 'Max Salary',
  currency: 'Currency',

  applicationHistory: 'Application History',
  screening: 'Screening',
  preSubInterview: 'Pre-Submission Interviews',
  submission: 'Submission',
  companyinterviews: 'Company Interviews',
  offer: 'Offer',
  hire: 'Hire',
  filter: 'Filters',
  viewresults: 'View Results',
  candidateedit: 'Candidate Edit',
  waitingapproval: 'waiting approval',
  accepted: 'Accepted',
  rejected: 'Rejected',
  isAccepted: 'Is Accepted by CrowdHRs',
  isAcceptedbyCompany: 'Is Accepted by Applied Company',
  stage: 'Stage',
  // status:"Status",
  progress: 'Progress',
  // country:"Country",
  // city:"City",
  // company:"Company",
  // job:"Job",
  // jobStatus:"Job Status",
  companyResponsible: 'Company Responsible',
  crowdHRsRecruiters: 'Crowd HRs Recruiters',
  referrerUsers: 'Referrer Users',
  candidateFilters: 'Candidate Filters',
  jobFilters: 'Job Filters',
  undoButton: 'Undo Accept/Reject',
  candidateProfile: 'Candidate Application Profile',

  forgotPassword: 'Forgot Password',
  candidateStatus: 'Candidate Status',
  educationLevel: 'Education Level',

  maxActivePrcs: 'Max Active Process',
  activePositions: 'Active Positions',
  nojobsFound: 'No Data found Please check your filters',
  jobdataloading: 'Your Jobs are loading Please wait..',
  referance: 'Reference',
  companySignup: 'Company Sign Up',
  companyEmail: 'Work Email',
  companynName: 'Company Name',
  comment: 'Comment',
  updateStatus: 'Update Status',
  changeStatus: 'Change Status',
  statusButtonErrorMessage: 'Please Select Related Status!!!',
  statusDescErrorMessage: 'Please Provide a Description',
  rejreason: 'Please Describe Your Reason',
  submitRejection: 'Submit Rejection',
  descriptionRejection: 'Rejection Description',
  referexistingCandidate: 'Refer Exiting Candidate: ',
  addCV: 'Add CV',
  cvFormat: 'PDF, JPG, PNG',
  uselatestCv: 'Use existing CV',
  uploadNewCv: 'Upload new CV',
  personaldataprotection: 'Personal Data Protection Rules',
  openindDate: 'Opening Date',
  editCandidate: 'Edit Candidate',
  loadingFile: 'Files are Uploading...',
  plsattachcv: 'Please Attach your CV',
  viewtimeline: 'View Timeline',
  note: 'Note',
  noteTypes: 'Note Types',
  addNotes: 'Add Note',
  mentioninnote: '@mention to notify users',
  loadingNode: 'Notes are Loading..',
  editNote: 'Edit Note',
  refernewcandidate: 'Refer New Candidate',
  cv: 'CV',
  displaycv: 'Display CV',
  message: 'MESSAGE',
  compose: 'Compose New Email',
  subject: 'Subject',
  template: 'Template',
  sendemail: 'Send Email',
  loadingmessages: 'Messages are Loading..',
  workemail: 'Work Email',
  companyweb: 'Company Website',
  activecandidates: 'Active Candidates',
  recruiters: 'RECRUITERS',
  emailconfirm: 'Please accept your email confirmation before you Login',
  noHistoryFound: 'No Data Found',
  loadingHistory: 'Almost There Please Wait...',
  addProfilePicture: 'Add Profile Picture',
  profileImgFormat: 'PNG, JPG, JPEG',
  imageoversize: ' Invalid file size, file size should be smaller than 7 KB',
  resetpassword: 'Send Password Reset Code',
  reset: 'Reset Password',
  confirmpassword: 'Confirm Your Password',
  makesureeqaul:
    'Make sure your confirmation password is same with your new password',
  newpassword: 'New Password',
  OK: 'OK',
  loading: 'Loading Please Wait...',
  birthday: 'Birth Date',
  altphone: 'Alternate Phone Number',
  language: 'Preferred Notification Language',
  linkedinProfile: 'Linkedin Profile',
  jobnoticekeyword: 'Job Notifications Keywords',
  information: 'Additional Details',
  saveprofile: 'Save Profile',
  profileinformation: 'Profile Information',
  profileSettings: 'Profile & Settings',
  getjobnotice: 'Get Job Opening Notifications',
  changeprofileimg: 'Change Profile Picture',
  changeprofilebackimg: 'Change Background Picture',
  secemail: 'Secondary Email',
  typekeyword: 'Type Your Keywords',
  mail: 'Mail',
  pPhone: 'Phone',
  joindate: 'Joining Date',
  linkedinprofile: 'LinkedIn Profile',
  code: 'Code',
  submit: 'Submit',
  chooseanewpassowrd: 'Create a new password',
  changepassword: 'Change Password',
  youcanchangeorreset: 'You can either change or reset your password',
  oldpassword: 'Current password',
  reteypenewpassword: 'Retype password',
  alljob: 'All Jobs',
  title: 'Title',
  sendpasslink: 'Set password or click send password reset link.',
  sendpassreset: 'Send password reset link',
  recruitertype: 'Recruitment Type',
  remoteWorkingType: 'Remote Working Type',
  postedafter: 'Posted After Date',
  applications: 'Applied/Referred Jobs',
  listcandidates: 'List Candidates',
  referrerUser: 'Referrer User',
  addnewcompany: 'Add New Company',
  suredelete: ' Are you sure you want to delete',
  norights: "You don't have right to  ",
  loadingplswait: 'Loading please wait...',
  useredit: 'Users Edit',
  waiting_approval: 'Waiting Approval',
  internalRecruiters: 'CrowdHRs Responsibles',
  jobdefinitions: 'JOB DEFINITION',
  canidatesearhckey: 'Candidate Search Keyword',
  appliedcompany: 'Applied Company',
  cvNotFound: 'CV Not Found',
  image: 'Image',
  crowdHRsResponsible: 'Crowd HRs Responsible',
  referToNewCandidate: 'Refer Candidate to a New Job',
}
